import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { useStyles } from '../adminStyles';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import DateFnsUtils from '@date-io/date-fns';
import {
  getVendors,
  deleteVendor,
  clearVendor,
} from '../../../redux/vendors/vendorActions';
import { Grid, Button, TextField, FormControlLabel, Checkbox } from '@material-ui/core';

import ExcelExport from './components/ExportExcel';
import VendorTable from './components/VendorTable';

const columns = [
  { id: 'vendorName', label: 'Name' },
  { id: 'vendorEmail', label: 'Email' },
  { id: 'website', label: 'Website' },
  { id: 'contactPName', label: 'Contact' },
  { id: 'action', label: 'Action' },
];

const VendorReport = props => {
  document.title = 'Sciata Vendors';

  const { gridElRight, gridElLeft, btnMobile, inputMobile } = useStyles();

  const dispatch = useDispatch();
  const vendorsList = useSelector(state => state.vendorsList.vendors || []);

  const [orderAscending, setOrderAscending] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [asc, setAsc] = useState('desc');
  const [rows, setRows] = useState([]);
  const [activeRecords, setActiveRecords] = useState(true);

  useEffect(() => {
    bindVendors();
  }, []);

  const bindVendors = () => dispatch(getVendors());

  useEffect(() => {
    setRows(
      vendorsList
        .filter(_vendor => {
          return _vendor.isActive === (activeRecords ? true : false);
        })
        .map(_vendors => {
          return { ..._vendors };
        })
    );
  }, [vendorsList, activeRecords]);

  const sortArray = (arr, property) => () => {
    let array = [...arr];
    setOrderAscending(!orderAscending);
    orderAscending ? setAsc('asc') : setAsc('desc');
    if (typeof property === 'string') {
      setRows(
        array.sort((a, b) => {
          let nameA = a.vendorName.toUpperCase();
          let nameB = b.vendorName.toUpperCase();

          if (orderAscending) {
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
            return 0;
          }
          if (!orderAscending) {
            if (nameB < nameA) {
              return -1;
            }
            if (nameB > nameA) {
              return 1;
            }
            return 0;
          }
        })
      );
    }
    property && orderAscending
      ? setRows(array.sort((a, b) => a[property] - b[property]))
      : setRows(array.sort((a, b) => b[property] - a[property]));

    property && !orderAscending
      ? setRows(array.sort((a, b) => b[property] - a[property]))
      : setRows(array.sort((a, b) => a[property] - b[property]));
    return array;
  };

  const setTheSearchTerm = e => setSearchTerm(e.target.value);

  const vendorTableProps = {
    columns,
    rows,
    sortArray,
    orderAscending,
    asc,
    searchTerm,
    activeRecords,
    ...props,
  };

  return (
    <>
      <h1>Vendor Management</h1>
      <Grid container justify='center' alignItems='center'>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <Grid item xs={12} md={4} className={gridElLeft}>
            <TextField
              variant='outlined'
              type='search'
              className={inputMobile}
              label='Search'
              value={searchTerm}
              onChange={setTheSearchTerm}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={activeRecords}
                  onClick={e => {
                    setActiveRecords(e.target.checked ? true : false);
                  }}
                  color='primary'
                />
              }
              label={'Active'}
            />
          </Grid>
          <Grid item xs={12} md={4} className={gridElRight}>
            <ExcelExport {...vendorTableProps} />
            <Button
              className={btnMobile}
              variant='contained'
              color='primary'
              startIcon={<PersonAddIcon />}
              onClick={() => {
                dispatch(clearVendor());
                props.history.push('/admin/vendordetails/0');
              }}
            >
              Add Vendor
            </Button>
          </Grid>
        </MuiPickersUtilsProvider>
      </Grid>
      <VendorTable
        {...vendorTableProps}
        deleteVendor={async (status, vendorId) => {
          const res = await dispatch(deleteVendor(status, parseInt(vendorId)));
          if (res) {
            dispatch(getVendors());
          }
        }}
      />
    </>
  );
};

export default withRouter(VendorReport);
